import React, { forwardRef, useRef, useMemo, useCallback, useImperativeHandle } from 'react';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.esm.js';

var DeleteDialog = /*#__PURE__*/forwardRef(function (props, ref) {
  var onConfirm = props.onConfirm,
    resourcesProps = props.resources,
    layoutName = props.layoutName,
    _props$fontSize = props.fontSize,
    fontSize = _props$fontSize === void 0 ? 'sm' : _props$fontSize;
  var confirmationDialogRef = useRef(null);
  var resources = useMemo(function () {
    return {
      confirm: function confirm() {
        return resourcesProps.confirm();
      },
      cancel: function cancel() {
        return resourcesProps.cancel();
      },
      title: function title() {
        return resourcesProps.title();
      },
      message: function message() {
        return resourcesProps.message({
          name: layoutName
        });
      }
    };
  }, [layoutName, resourcesProps]);
  var open = useCallback(function () {
    var _confirmationDialogRe;
    (_confirmationDialogRe = confirmationDialogRef.current) === null || _confirmationDialogRe === void 0 ? void 0 : _confirmationDialogRe.open();
  }, []);
  var close = useCallback(function () {
    var _confirmationDialogRe2;
    (_confirmationDialogRe2 = confirmationDialogRef.current) === null || _confirmationDialogRe2 === void 0 ? void 0 : _confirmationDialogRe2.close();
  }, []);
  var isOpen = useMemo(function () {
    var _confirmationDialogRe3;
    return ((_confirmationDialogRe3 = confirmationDialogRef.current) === null || _confirmationDialogRe3 === void 0 ? void 0 : _confirmationDialogRe3.isOpen) === true;
  }, []);
  useImperativeHandle(ref, function () {
    return {
      open: open,
      close: close,
      isOpen: isOpen
    };
  });
  return /*#__PURE__*/React.createElement(ConfirmationDialog, {
    ref: confirmationDialogRef,
    resources: resources,
    onConfirm: onConfirm,
    fontSize: fontSize
  });
});
DeleteDialog.displayName = 'DeleteDialog';

export { DeleteDialog };
//# sourceMappingURL=delete-dialog.esm.js.map
